import { CelitoModule, Tab } from '@celito.clients/types';
import { getUrlForTab } from '@celito.clients/utils';

export const getDetailsViewUrl = (
  detailViewName: string,
  recordName: string,
  version?: string,
  userModules?: CelitoModule[],
  moduleName?: string
) => {
  const prefixUlr = getUrlForTab(
    userModules?.find((m) => m.label === moduleName) as CelitoModule,
    detailViewName as unknown as Tab
  );

  const url = `${prefixUlr}view/${detailViewName}/${recordName}`;
  return version ? `${url}?version=${version}` : url;
};
